import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-main-section">
      <div className="about" data-aos="fade-right"></div>
      <div className="about-me-text">
        <h2>
          Frontend developer who cares deeply about user experience. Serious
          passion for UI design and new technologies.
        </h2>
      </div>
    </div>
    // mongodb+srv://rsm-ecommerce:2UfZByQIHUdNXrRI@cluster0.enpeg.mongodb.net/ecommerce?retryWrites=true&w=majority
  );
};

export default About;
